// @ts-nocheck
import React, { Fragment, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, Transition } from '@headlessui/react';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ArrowRightOnRectangleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { URL } from '../../service/Service';
import { useTranslation } from '../../i18n/LanguageContext';

const LogoutModal = ({ isOpen }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const cancelButtonRef = useRef();
  const navigate = useNavigate();

  const handleModalOpen = () => {
    setError(null);
    setOpen(true);
  };

  const handleModalClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    // Perform logout logic
    await logoutUser();

    // Close the sidebar if it was open
    if (isOpen) {
      isOpen(false);
    }
  };


  const logoutUser = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${URL}/api/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          setError(t('logout.expired'));
        } else {
          setError(t('logout.error'));
        }
      } else {
        handleLogoutSuccess();
      }
    } catch (error) {
      console.error(error);
      setError(t('logout.error'));
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogoutSuccess = () => {
    sessionStorage.removeItem('jwt');
    navigate('/');
    setOpen(false);
  };

  return (
    <>
     <button
  onClick={handleModalOpen}
  className="group p-4 flex text-sm items-center text-gray-300 hover:text-blue-leve flex-grow w-full h-full cursor-pointer"
>
  <FontAwesomeIcon
    icon={faSignOutAlt}
    className="mr-6 text-gray-300 hover:text-gray-300 flex-shrink-0 h-5 w-6"
  />
  <span className="mr-6 text-gray-300 hover:text-blue-leve">
    {isOpen ? t('nav.logout') : null}
  </span>
</button>

      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={handleModalClose}
        >
          <div className="flex min-h-screen items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-950/45 backdrop-blur-[2px] transition-opacity" />
            </Transition.Child>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div
                className="relative w-full max-w-md overflow-hidden rounded-2xl bg-white text-left shadow-2xl ring-1 ring-black/5 transition-all"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-headline"
              >
                <div className="h-1 w-full bg-green-cl" />
                <button
                  type="button"
                  onClick={handleModalClose}
                  aria-label={t('common.close')}
                  className="absolute right-4 top-5 rounded-lg p-1.5 text-gray-400 transition hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-green-cl"
                >
                  <XMarkIcon className="h-5 w-5" />
                </button>

                <div className="p-6 sm:p-7">
                  <div className="flex items-start gap-4 pr-8">
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-green-50 text-green-cl ring-1 ring-green-100">
                      <ArrowRightOnRectangleIcon className="h-6 w-6" aria-hidden="true" />
                    </div>
                    <div>
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-black leading-6 text-gray-950"
                    >
                      {t('logout.title')}
                    </Dialog.Title>
                    <div className="mt-2.5">
                      <p className="text-sm leading-6 text-gray-600">
                        {t('logout.description')}
                      </p>
                    </div>
                  </div>
                </div>

                {error && (
                  <div className="mt-5 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-700">
                    {error}
                  </div>
                )}

                <div className="mt-7 flex flex-col-reverse gap-3 border-t border-gray-100 pt-5 sm:flex-row sm:justify-end">
                  <button
                    type="button"
                    disabled={isLoading}
                    className="inline-flex min-h-[44px] w-full items-center justify-center rounded-xl border border-gray-300 bg-white px-5 py-2.5 text-sm font-bold text-gray-700 transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-cl focus:ring-offset-2 disabled:opacity-50 sm:w-auto"
                    onClick={handleModalClose}
                    ref={cancelButtonRef}
                  >
                    {t('common.cancel')}
                  </button>
                  <button
                    type="button"
                    disabled={isLoading}
                    className="inline-flex min-h-[44px] w-full items-center justify-center gap-2 rounded-xl bg-green-cl px-5 py-2.5 text-sm font-bold text-white shadow-sm transition hover:-translate-y-0.5 hover:bg-green-900 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-green-cl focus:ring-offset-2 disabled:cursor-wait disabled:translate-y-0 disabled:opacity-60 sm:w-auto"
                    onClick={handleLogout}
                  >
                    <ArrowRightOnRectangleIcon className="h-4 w-4" />
                    {isLoading ? t('logout.loading') : t('logout.confirm')}
                  </button>
                </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default LogoutModal;
